// extracted by mini-css-extract-plugin
export default {"auction-list-header":"auction-list-header--2eyEJ"};
    if(module.hot) {
      // 1747648148932
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  